import { graphql } from 'gatsby'
import { JsonLd } from 'react-schemaorg'
import { Brand, IndividualProduct } from 'schema-dts'

import Layout from '../../../components/layout'
import Seo from '../../../components/seo'
import Benefits from '../../../components/Benefits'
import InfoBoxes from '../../../components/InfoBoxes'
import { TrustPilotSmall } from '../../../components/TrustPilot/Trustbox'

import generateWatchProjectImage from '../../../utils/generateWatchProjectImage'
import SellBuyDecisionDivider from '../../../components/Hero/SellBuyDecisionDivider'
import { BUYING_CATALOG_ROUTE, SELLING_SEARCH_ROUTE } from '../../../utils/routes/const'
import { useTranslation } from 'react-i18next'
import { dateFormatOptions } from '../../../utils/i18n/format'
import { useI18next } from 'gatsby-plugin-react-i18next'
import Link from '../../../components/Atoms/Link'
import { ArrowDown } from '../../../components/Atoms/ArrowButton'

interface BuyingPageProps {
  data: {
    seoMagazine: WatchProject21Api.SeoMagazine
  }
}

const VirtualMagazinePage = ({ data }: BuyingPageProps) => {
  const { seoMagazine } = data;
  const { t } = useTranslation();
  const { language } = useI18next();

  const sellingLink = `${SELLING_SEARCH_ROUTE}?brand[]=${seoMagazine?.brand?.name || ''}&model[]=${seoMagazine.model?.name || ''}`;
  const buyingLink = `${BUYING_CATALOG_ROUTE("")}?brandName=${seoMagazine?.brand?.name || ''}&modelName=${seoMagazine.model?.name || ''}`;

  return (
    <Layout bgColor='bg-white' footerColor='bg-gray' hasStickyChildren>
      <Seo title={seoMagazine.metaTitle} />
      {/* TODO */}
      {/* <JsonLd<Brand>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Brand',
          name: `${watch.brand?.name || ''} ${watch.model?.name || ''} ${watch.referenceNumber || ''}`,
          image: generateWatchProjectImage(seoWatch.imagePath, watch.referenceNumber),
          brand: watch.brand?.name,
          model: watch.model?.name,
          sku: watch.referenceNumber,
          description: seoWatch.description,
          offers: {
            '@type': 'Offer',
            price: seoWatch.price,
            priceCurrency: 'EUR',
            availability: 'https://schema.org/InStock',
            url: `https://www.watchproject21.com/comprar/productos/${seoWatch.watch__slug}`,
          },
        }}
      /> */}
      <div className="max-w-screen-2xl mx-auto py-32 flex flex-col lg:flex-row">
        <div className="lg:w-1/3 lg:mr-32 lg:sticky top-16 self-start">
          <h1 className="font-cirka text-primary text-6xl mb-12">{seoMagazine.heading || seoMagazine.title}</h1>
          <div>{seoMagazine?.brand?.name} {seoMagazine?.model?.name}</div>
          <h2 className="font-cirka text-xl mb-8" >{seoMagazine.subTitle}</h2>
          <time className="text-gray-400 text-lg" dateTime={seoMagazine.createdAt}>{new Date(seoMagazine.createdAt).toLocaleDateString(language, dateFormatOptions)}</time>
        </div>
        <div className="lg:w-2/3">
          <div className="grid grid-cols-3">
            {seoMagazine.images.map((image, index) => (
              <figure key={`seoMagazine-images-${index}`}>
                <img src={generateWatchProjectImage(image.image, '')} alt={image.altText} />
                <figcaption className="text-md mt-2 font-bold"><center>{image.altText}</center></figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
      <SellBuyDecisionDivider
        t={t}
        sellingLink={sellingLink}
        buyingLink={buyingLink}
        wrapperClassName="flex text-center flex-col items-center justify-center"
      />
      <div className="max-w-screen-2xl mx-auto mt-32 flex flex-col lg:flex-row">
        {seoMagazine.text && (<div className="content content-formatted" dangerouslySetInnerHTML={{ __html: seoMagazine.text }} />)}
      </div>
      <InfoBoxes />
      <Benefits />
      <TrustPilotSmall />
    </Layout>
  )
}

export default VirtualMagazinePage

export async function config() {
  return () => ({
    defer: true,
  })
}

export const query = graphql`
  query($language: String!, $slug: String!) {
    seoMagazine: seoMagazine(slug: {eq: $slug }) {
      title
      subTitle
      metaTitle
      metaDescription
      text
      createdAt
      images {
        altText
        image
      }
      model {
        name
      }
      brand {
        name
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`

